export default __webpack_public_path__ + "static/media/ceo.56cea592.jpg";